const prefix = 'MESSAGE_DRAFT_'
const prefixUID = (uid: string) => `${prefix}${uid}`
export default prefixUID
